<template>
  <div>
    <!-- 退换货办理 -->
    <div class="rj-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'returnExchangeChief' }">
          合同列表
        </el-breadcrumb-item>
        <el-breadcrumb-item>退货合同</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <baseInfo ref="baseInfo" :info="info" />
    <UploadInvoice />
    <history ref="history" :approve-log-list="approveLogList" />
    <product ref="productList" :product-data="productData" @setProductSn="setProductSn" />
    <el-button type="primary" @click="submit">
      提交并前往盖章
    </el-button>
  </div>
</template>

<script>
import baseInfo from './baseInfo';
import UploadInvoice from './invoice-file/upload.vue';
import history from './history.vue';
import product from './product.vue';
import { getApproveData, submitToSignR, saveProductSerialNum } from '@/API';

export default {
  components: {
    baseInfo,
    UploadInvoice,
    history,
    product
  },

  data () {
    return {
      info: {},
      approveLogList: [],
      productData: [],
      productSnNumber: {
        contractDeliveries: [],
        contractId: null
      }
    };
  },
  props: {

  },
  methods: {
    setProductSn (val) {
      this.productSnNumber.contractDeliveries = val;
    },
    submit () {
      let history = this.$refs.history.rejectedList;
      console.log(history);
      let parmas = {
        baseInfoModelVO: this.$refs.baseInfo.info,
        approveLogList: this.$refs.history.approveLogList,
        addressMOdelVOS: this.$refs.productList.rejectedList
      };
      this.productSnNumber.contractId = parmas.baseInfoModelVO.contractId;
      saveProductSerialNum(this.productSnNumber).then((res) => {
      });
      submitToSignR(parmas).then((res) => {
        let json = res.data;
        console.log(json);
        if (json.status === '200') {
          this.$router.push({ 'name': 'chiefReturnbFile', query: { contractId: this.$route.query.rcontractId } });
        }
      }).catch(() => {

      });
      // if (parmas.baseInfoModelVO.rreasonType !== '齐套不提货撤单') {
      //   this.productSnNumber.contractId = parmas.baseInfoModelVO.contractId;
      //   saveProductSerialNum(this.productSnNumber).then((res) => {
      //     if (res.data.status === '200') {
      //       submitToSignR(parmas).then((res) => {
      //         let json = res.data;
      //         console.log(json);
      //         if (json.status === '200') {
      //           this.$router.push({ 'name': 'chiefReturnbFile', query: { contractId: this.$route.query.rcontractId } });
      //         }
      //       }).catch(() => {
      //       });
      //     }
      //   });
      // } else {
      //   submitToSignR(parmas).then((res) => {
      //     let json = res.data;
      //     console.log(json);
      //     if (json.status === '200') {
      //       this.$router.push({ 'name': 'chiefReturnbFile', query: { contractId: this.$route.query.rcontractId } });
      //     }
      //   }).catch(() => {

      //   });
      // }
    },
    initData () {
      // let parmas = {
      //   contractId: this.$route.query.contractId
      // };
      getApproveData(this.$route.query.rcontractId, this.$route.query.rcontractType).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$nextTick(() => {
            this.info = json.data.baseInfoModelVO;
            this.approveLogList = json.data.approveLogList;
            this.productData = json.data.addressMOdelVOS;
          });
        }
      }).catch(() => {

      });
    }
  },

  mounted () {
    this.initData();
  }
};
</script>
